import { render } from "./card-list-assessmen-profesi.vue?vue&type=template&id=19885dfa&scoped=true"
import script from "./card-list-assessmen-profesi.vue?vue&type=script&lang=js"
export * from "./card-list-assessmen-profesi.vue?vue&type=script&lang=js"

import "./card-list-assessmen-profesi.vue?vue&type=style&index=0&id=19885dfa&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19885dfa"]])

export default __exports__